import { Component, OnInit } from '@angular/core';
import { AutorizacionService} from '../services/autorizacion.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent  {
  loginParams:any={};
  constructor(private autorizacionService: AutorizacionService) {     
  }
  testar(){
    console.log("click test")
  }
  loginAuth(){
    //this.autorizacionService.login(this.loginParams.email,this.loginParams.password);
    this.autorizacionService.login('jaimeivan0017@gmail.com','123456');
  }

  //
  facebookLogin(){
    this.autorizacionService.facebookLogin();
  }

}



// WEBPACK FOOTER //
// C:/Users/USUARIO/Documents/Platzi/cursos__2017/Angular_4_PROFESIONAL/proyectos/platzisquare2/src/app/login/login.component.ts